<template>
    <div :class="[$style.mobile]" >
        <div :class="[$style.chat__main]">
            <slot></slot>
        </div>
    </div>
</template>

<script>
module.exports = {
  props: ['name']
}
</script>

<style scoped module lang="scss">
    .chat__main {
        width: 100%;
        height: auto;
        display: inline-block;
        -webkit-border-radius: 6px;
        -moz-border-radius: 6px;
        border-radius: 6px;
        border: 1px solid rgba(217,217,217, .3);
        -webkit-box-shadow: -1px 4px 5px 0px rgba(214,214,214,.5);
        -moz-box-shadow: -1px 4px 5px 0px rgba(214,214,214,.5);
        box-shadow: -1px 4px 5px 0px rgba(214,214,214,.5);
        overflow: hidden;
        position: relative;
        padding-top: 42px;
        background: #fff;

    }
</style>